import { CHAT_ACTIONS, Message, ToolCall, ExecutionLayer } from '../actions/chatActions';

export interface ChatState {
  messages: (Message | ToolCall)[];
  isLoading: boolean;
  layerResults?: { [key: number]: any };
  executionLayers?: ExecutionLayer[];
  currentLayerIndex?: number;
  allResults?: { [key: string]: any };
}

const initialState: ChatState = {
  messages: [],
  isLoading: false,
  executionLayers: [],
  currentLayerIndex: 0,
  allResults: {},
};

const chatReducer = (
  state: ChatState = initialState,
  action: any
): ChatState => {
  
  switch (action.type) {
    case CHAT_ACTIONS.ADD_MESSAGE:
      const newState = {
        ...state,
        messages: [...state.messages, action.payload],
      };
      return newState;

    case CHAT_ACTIONS.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case CHAT_ACTIONS.CLEAR_CHAT:
      return {
        ...state,
        messages: [],
        isLoading: false,
        executionLayers: [],
        currentLayerIndex: 0,
        allResults: {},
      };

    case CHAT_ACTIONS.TOGGLE_TOOL_CALL:
      return {
        ...state,
        messages: state.messages.map((msg, index) =>
          index === action.payload
            ? { ...msg, isExpanded: !msg.isExpanded }
            : msg
        ),
      };

    case CHAT_ACTIONS.SET_EXECUTION_LAYERS:
      return {
        ...state,
        executionLayers: action.payload,
        currentLayerIndex: 0,
      };

    case CHAT_ACTIONS.UPDATE_LAYER_STATUS:
      return {
        ...state,
        executionLayers: state.executionLayers?.map(layer =>
          layer.layerIndex === action.payload.layerIndex
            ? {
                ...layer,
                status: action.payload.status,
                endTime: action.payload.status === 'completed' || action.payload.status === 'failed' 
                  ? new Date() 
                  : layer.endTime,
                agents: layer.agents.map(agent => ({
                  ...agent,
                  result: action.payload.results?.[agent.agent] || agent.result,
                }))
              }
            : layer
        ),
        allResults: action.payload.results 
          ? { ...state.allResults, ...action.payload.results }
          : state.allResults,
      };

    case CHAT_ACTIONS.UPDATE_TOOL_CALL_STATUS:
      return {
        ...state,
        messages: state.messages.map(msg => {
          if (msg.sender === 'toolCall' && (msg as ToolCall).id === action.payload.toolCallId) {
            return {
              ...msg,
              status: action.payload.status,
              content: action.payload.content || (msg as ToolCall).content,
              error: action.payload.error,
              endTime: action.payload.status === 'completed' || action.payload.status === 'failed' 
                ? new Date() 
                : (msg as ToolCall).endTime,
            } as ToolCall;
          }
          return msg;
        }),
      };

    case CHAT_ACTIONS.SET_CURRENT_LAYER:
      return {
        ...state,
        currentLayerIndex: action.payload,
      };

    default:
      return state;
  }
};

export default chatReducer; 